// Helper function to ensure that an input with the type="number" only accepts natural numbers
export const UseNaturalNumbers = (evt) => evt.key === 'e' && evt.preventDefault()
  || evt.key === 'E' && evt.preventDefault()
  || evt.key === '+' && evt.preventDefault()
  || evt.key === '-' && evt.preventDefault()
  || evt.key === '=' && evt.preventDefault();
